export const GET_DASHBOARD_VIEWS = 'GET_DASHBOARD_VIEWS';
export const GET_DASHBOARD_VIEWS_SUCCESS = 'GET_DASHBOARD_VIEWS_SUCCESS';
export const GET_DASHBOARD_VIEWS_ERROR = 'GET_DASHBOARD_VIEWS_ERROR';

export const SAVE_DASHBOARD = 'SAVE_DASHBOARD';
export const SAVE_DASHBOARD_SUCCESS = 'SAVE_DASHBOARD_SUCCESS';
export const SAVE_DASHBOARD_ERROR = 'SAVE_DASHBOARD_ERROR';

export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR';

export const DASHBOARD_ADD_VIEW = 'DASHBOARD_ADD_VIEW';
export const DASHBOARD_ADD_VIEW_SUCCESS = 'DASHBOARD_ADD_VIEW_SUCCESS';
export const DASHBOARD_ADD_VIEW_ERROR = 'DASHBOARD_ADD_VIEW_ERROR';

import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export function getViews(masterAccountId) {
  return async dispatch => {
    dispatch({ type: GET_DASHBOARD_VIEWS });
    const viewResults = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views`, {
      params: {
        contextName: 'dashboard_landing'
      }
    });
    if (viewResults?.status === 200) {
      dispatch({
        type: GET_DASHBOARD_VIEWS_SUCCESS,
        views: viewResults.data.data.views,
        defaultView: viewResults.data.data.views.find(view => view.view_pk === viewResults.data.data.defaultViewId)
      });
    } else {
      addAlert('Failed to retrieve dashboard views.', 'danger', 5000);
      dispatch({ type: GET_DASHBOARD_VIEWS_ERROR });
    }
  };
}

export function saveDashboard(viewId, boardLayout) {
  return async dispatch => {
    dispatch({ type: SAVE_DASHBOARD });
    const saveResults = await apiClient.apiPost('/api/home/dashboard/save/saveDashboard', {
      viewPk: viewId,
      boardLayout
    });
    if (saveResults?.status === 200) addAlert('Saved dashboard layout.', 'success', 3000);
    else addAlert('Saving dashboard failed.', 'danger', 5000);
  };
}

export function getDashboard(masterAccountId, view) {
  return async dispatch => {
    dispatch({ type: GET_DASHBOARD });
    let lastViewed;
    if (!view) {
      lastViewed = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        params: {
          contextName: 'dashboard_landing'
        }
      });
      if (lastViewed?.status === 200) {
        lastViewed = lastViewed.data.data;
        view = lastViewed;
      } else {
        addAlert('Failed to retrieve dashboard cards.', 'danger', 5000);
        dispatch({ type: GET_DASHBOARD_ERROR });
      }
    }
    const getResults = await apiClient.apiGet('/api/home/dashboard/retrieve/getDashboard', {
      params: {
        viewPk: view.view_pk
      }
    });
    if (getResults?.status === 200) {
      if (!lastViewed) {
        await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
          contextName: 'dashboard_landing',
          viewId: view.view_pk
        });
      }
      dispatch({ type: GET_DASHBOARD_SUCCESS, view, cards: getResults.data.cards });
    } else {
      addAlert('Failed to retrieve dashboard cards.', 'danger', 5000);
      dispatch({ type: GET_DASHBOARD_ERROR });
    }
  };
}

export function upsertView(masterAccountId, name, scope, description, isDefaultView, viewPk) {
  return async dispatch => {
    dispatch({ type: DASHBOARD_ADD_VIEW });
    const requestBody = {
      name,
      scope,
      description,
      isDefaultView
    };
    if (viewPk) requestBody.viewPk = viewPk;
    const upsertResults = await apiClient.apiPost('/api/home/dashboard/add/upsertView', requestBody);
    if (upsertResults?.status === 200) {
      if (isDefaultView) {
        await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/set-default`, {
          pageCode: 'dashboard_landing',
          viewId: upsertResults.data.view_pk
        });
      }
      if (viewPk) addAlert(`Updated dashboard '${name}'.`, 'success', 3000, 'top-right');
      else addAlert(`Added new dashboard '${name}'.`, 'success', 3000, 'top-right');
    }
  };
}

export function deleteView(viewPk) {
  return async () => {
    const errorMessage = 'Error removing view';
    const successMessage = 'Successfully deleted view';
    try {
      const deleteResults = await apiClient.apiDelete('/api/home/dashboard/delete/deleteView', {
        data: {
          viewPk
        }
      });
      if (deleteResults?.status === 200) {
        addAlert(successMessage, 'success', 3000, 'top-right');
      } else {
        addAlert(errorMessage, 'danger', 5000, 'top-right');
      }
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
      console.error(error);
    }
  };
}

export function copyView(view) {
  return async () => {
    const errorMessage = 'Error copying view';
    const successMessage = 'Successfully copied view';
    try {
      const copyResults = await apiClient.apiPost('/api/home/dashboard/copy/copyView', {
        viewPk: view.view_pk,
        newName: view.view_name,
        newDescription: view.view_description
      });
      if (copyResults?.status === 200) {
        addAlert(successMessage, 'success', 3000, 'top-right');
      } else {
        addAlert(errorMessage, 'danger', 5000, 'top-right');
      }
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
    }
  };
}
